// extracted by mini-css-extract-plugin
export default {"checkbox":"affiliateCreationForm_checkbox__fTP3B","input":"affiliateCreationForm_input__bu5HU"};